<template>
  <div>
    <Search />
    <div style="height: 112px; width: 100%" />
    <div class="container">
      <el-table :data="list" style="width: 100%">
        <el-table-column label="优惠券名称">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="金额">
          <template slot-scope="scope">
            {{ scope.row.amount }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="优惠码">
          <template slot-scope="scope">
            {{ scope.row.code }}
          </template>
        </el-table-column> -->
        <el-table-column label="优惠卷类型">
          <template slot-scope="scope">
            {{ scope.row.type | formatStat }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="领取日期">
          <template slot-scope="scope">
            {{ scope.row.enableTime | formatTime }}
          </template>
        </el-table-column> -->
        <el-table-column label="到期日">
          <template slot-scope="scope">
            {{ scope.row.endTime | formatTime }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleDown(scope.row)">
              领取
            </el-button>
            <el-button size="mini" type="text" @click="showSkip(scope.row)">
              立即使用
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          :current-page="orderParam.pageNum"
          :page-sizes="[10, 15, 20, 25]"
          :page-size="orderParam.pageSize"
          layout="total,sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Search from '@/components/Search'
import { fetchMemberCouponList } from '@/api/coupon.js'

export default {
  name: 'AllCoupon',
  components: {
    Search
  },
  filters: {
    formatStat(type) {
      if (type === 0) {
        return '全场赠券'
      } else if (type === 1) {
        return '会员赠券'
      } else if (type === 2) {
        return '购物赠券'
      } else if (type === 3) {
        return '注册赠券'
      }
    },
    formatTime(time) {
      const dateString = time
      const date = new Date(dateString)
      const year = date.getFullYear()
      let month = date.getMonth() + 1 // getMonth() 返回的月份从0开始，所以需要+1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()

      // 为了保持两位数，当小于10的时候，前面补0
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    }
  },
  props: {
    status: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  data() {
    return {
      list: [],
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
      orderParam: {
        pageNum: 1,
        pageSize: 10
        // status: 6,
      }
    }
  },
  mounted() {
    this.getGiftCardList()
  },
  methods: {
    // 每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.orderParam.pageNum = 1
      this.orderParam.pageSize = val
      this.getGiftCardList()
    },
    // 当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.orderParam.pageNum = val
      this.getGiftCardList()
    },
    // 查询列表
    getGiftCardList() {
      const params = {
        // pageNum: this.orderParam.pageNum,
        // pageSize: this.orderParam.pageSize,
        // useStatus: 0
      }
      fetchMemberCouponList(params).then(res => {
        if (res.code === 200) {
          this.list = res.data
          this.total = res.data.total
        } else {
          this.list = []
        }
      })
    },
    // 跳转商品
    showSkip(val) {
      // console.log(val)
      this.$router.push({ path: '/goodsList', query: { keyword: '' }})
    },
    // 领取
    handleDown(val) {
      // console.log(val)
    }
  }
}
</script>
<style scoped>
.container {
  margin: 0 auto;
  width: 1250px;
  min-width: 1250px;
  /* --main-color: #0063ef; */
  --dark-color: #2b2b2b;
  --main-color:#F6713D

}
</style>
